import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, Typography, Container, Card, Link, Stack } from "@mui/material";
import Carousel from "nuka-carousel";
import back from "../../assets/Arrows/back-arrow.svg";
import forward from "../../assets/Arrows/forward-arrow.svg";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { NextButton, BackButton } from "../../utils/theme.js";

const TeamMobile = (props) => {
  const { t } = useTranslation();

  return (
    <Grid
      container
      flexDirection="column"
      justifyContent="center"
      mb={10}
      mt={-5}
      sx={{
        display: props.display,
      }}
    >
      <Typography variant="h2" mb={1.5}>
        {t("teamComponent.title")}
      </Typography>
      <Typography variant="h4" textAlign="center" mb={-1.2}>
        {t("teamComponent.subTitle")}
      </Typography>
      <Container
        sx={{
          width: { xs: "95%", sm: "90%", md: "80%", lg: "65%" },
          height: "87%",
        }}
      >
        <Carousel
          autoplayInterval={15000}
          transitionMode="fade"
          wrapAround
          autoplay
          renderCenterLeftControls={({ previousSlide }) => (
            <BackButton onClick={previousSlide}>
              <img src={back} alt="back-button" height="auto" width="auto" />
            </BackButton>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <NextButton onClick={nextSlide}>
              <img src={forward} alt="next-button" height="auto" width="auto" />
            </NextButton>
          )}
          renderBottomCenterControls={() => null}
        >
          {props.team.map((member, index, array) => (
            <Grid
              container
              flexDirection="column"
              alignItems="center"
              key={`teamMemb:${member.linkedin}`}
            >
              <Grid
                container
                item
                md={12}
                justifyContent="center"
                alignItems="flex-start"
                marginTop={1.5}
                paddingX={{ xs: 0, md: 20 }}
              >
                {index === 0 ? (
                  <Card style={{ marginRight: "-80px", marginTop: 100 }}>
                    <img
                      src={array[array.length - 1].image}
                      alt={array[array.length - 1].name}
                      width="100%"
                      height="auto"
                    ></img>
                  </Card>
                ) : (
                  <Card style={{ marginRight: "-80px", marginTop: 100 }}>
                    <img
                      src={array[index - 1].image}
                      alt={array[index - 1].name}
                      width="100%"
                      height="auto"
                    ></img>
                  </Card>
                )}
                <Stack
                  width="220px"
                  height="fit-content"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "50px",
                  }}
                >
                  <img
                    src={member.image}
                    width="100%"
                    height="auto"
                    alt={member.name}
                  ></img>
                  <Typography variant="h3" textAlign="center" mt={3}>
                    {member.name}
                  </Typography>
                  <Typography
                    variant="h4"
                    textAlign="center"
                    mt={1}
                    mb={2}
                    width="80vw"
                  >
                    {member.title}
                  </Typography>
                </Stack>
                {index === array.length - 1 ? (
                  <Card style={{ marginLeft: "-80px", marginTop: 100 }}>
                    <img
                      src={array[0].image}
                      alt={array[0].name}
                      width="100%"
                      height="auto"
                    ></img>
                  </Card>
                ) : (
                  <Card style={{ marginLeft: "-80px", marginTop: 100 }}>
                    <img
                      src={array[index + 1].image}
                      alt={array[index + 1].name}
                      width="100%"
                      height="auto"
                    ></img>
                  </Card>
                )}
              </Grid>
              {member.linkedin && (
                <Link
                  target="_blank"
                  href={member.linkedin}
                  aria-label={member.linkedin}
                >
                  <LinkedInIcon color="icon" fontSize="large" />
                </Link>
              )}
            </Grid>
          ))}
        </Carousel>
      </Container>
    </Grid>
  );
};
export default TeamMobile;
